import { connect } from 'react-redux'
import PlusMinusBtn from './PlusMinusBtn'

const mapStateToProps = () => ({})

const mapDispatchToProps = () => ({})

export default connect(mapStateToProps, mapDispatchToProps)(PlusMinusBtn)
